import { axiosAuth } from '../helper/axios-auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

interface CreateUserArgs {
  email: string;
  name: string;
  cpf: string;
  phone: string;
}

export const createUser = createAsyncThunk(
  'user/create',
  async (userData: CreateUserArgs, { rejectWithValue }) => {
    try {
      const axios = await axiosAuth();
      const response = await axios.post('/namu/createUser', userData);
      return response.data;
    } catch (e) {
      const error = handleUserCreationError(e as AxiosError);
      return rejectWithValue(error);
    }
  },
);

interface ErrorMessage {
  message?: string;
  status?: number | null;
}

const handleUserCreationError = (error: AxiosError): ErrorMessage => {
  if (error.response) {
    const errors: { [key: number]: string } = {
      422: 'Formato de parâmetros inválido.',
    };

    const { status } = error.response;

    return {
      message: errors[status] || 'Erro desconhecido.',
      status,
    };
  }

  if (error.message === 'Network Error') {
    return {
      message: 'Verifique a sua conexão e tente novamente.',
      status: null,
    };
  }

  return {
    message: 'Ocorreu um erro. Tente novamente mais tarde.',
    status: 500,
  };
};
